import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";
import { CustomerLocationFieldsFragment } from "~/gql/queries/customer.generated";

interface LocationsState {
	locationFormOpen: boolean;
	ruleFormOpen: boolean;
	selectedLocation: CustomerLocationFieldsFragment | null;
	viewType: ViewType;
}

const initialState: LocationsState = {
	locationFormOpen: false,
	ruleFormOpen: false,
	selectedLocation: null,
	viewType: "card"
};

const locationsSlice = createSlice({
	initialState,
	name: "restockLocations",
	reducers: {
		closeLocationForm: (state) => {
			state.locationFormOpen = false;
		},
		closeLocationRuleForm: (state) => {
			state.ruleFormOpen = false;
		},
		openLocationForm: (state) => {
			state.locationFormOpen = true;
		},
		openLocationRuleForm: (state) => {
			state.ruleFormOpen = true;
		},
		setSelectedLocation: (state, action: PayloadAction<CustomerLocationFieldsFragment | null>) => {
			state.selectedLocation = action.payload;
		},
		setViewType: (state, action: PayloadAction<ViewType>) => {
			state.viewType = action.payload;
		}
	}
});

export const {
	closeLocationForm,
	closeLocationRuleForm,
	openLocationForm,
	openLocationRuleForm,
	setSelectedLocation,
	setViewType
} = locationsSlice.actions;

export default locationsSlice.reducer;
